import { useEffect, Suspense } from "react";
import "./App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import axios from "axios";
import Landing from "./pages/Landing";
import Mantenimiento from "./pages/Mantenimiento";
import Optimizacion from "./pages/Optimizacion";
import Hosting from "./pages/Hosting";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import Terminos from "./pages/Terminos";
import Privacidad from "./pages/Privacidad";
import { Toaster } from "./components/ui/toaster";
import GoogleAnalytics from "./components/GoogleAnalytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  useEffect(() => {
    // Fuerza tema oscuro global para evitar bajo contraste en algunos entornos
    document.documentElement.classList.add("dark");

    const helloWorldApi = async () => {
      try {
        if (!BACKEND_URL) return; // evita request innecesaria en producción estática
        const response = await axios.get(`${API}/`);
        console.log(response.data.message);
      } catch (e) {
        console.error(e, `errored out requesting / api`);
      }
    };

    helloWorldApi();
  }, []);

  return <Landing />;
};

function App() {
  // Configura tu Google Analytics Measurement ID aquí
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';
  
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Cargando...</div>}>
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <GoogleAnalytics measurementId={GA_MEASUREMENT_ID} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mantenimiento-wordpress" element={<Mantenimiento />} />
              <Route path="/optimizacion-velocidad-wordpress" element={<Optimizacion />} />
              <Route path="/hosting-wordpress" element={<Hosting />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin-wprescate24" element={<Admin />} />
              <Route path="/terminos" element={<Terminos />} />
              <Route path="/privacidad" element={<Privacidad />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </HelmetProvider>
    </Suspense>
  );
}

export default App;